import "./PublicServices.module.css";
import Header from "@/reusable_sections/Header";
import OurPublicCommitments from "./sections/OurPublicCommitments";
import ServiceInquiry from "./sections/ServiceInquiry";
import Footer from "@/reusable_sections/Footer";
export default function PublicServicesPage() {
  return <div>
      <Header />
      <OurPublicCommitments />
      <ServiceInquiry />
      <Footer />
    </div>;
}